import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'querystringify';
import {
  Box,
  Button,
  Card,
  Page,
  ResourceList,
  RouterLink,
  Text,
} from '../components';
import api from '../utils/services';

const propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default class Forms extends Component {
  constructor(props) {
    super(props);
    this.state = { forms: null };
  }

  componentDidMount() {
    const { match: { params: { carrierId } } } = this.props;
    api.getForms(qs.stringify({ limit: 10, offset: 0, carrierId }, true))
      .then((data) => {
        this.setState({ forms: data });
      });
  }

  render() {
    const { match } = this.props;
    const { forms } = this.state;

    return (
      <Page
        title="Forms (On Hold)"
        subtitle="Manage and customize your forms"
        primaryAction={{ content: 'Add form', href: `${match.url}/new` }}
      >
        <Card loading={forms === null}>
          <ResourceList
            resourceName={{ singular: 'form', plural: 'forms' }}
            items={forms || []}
            renderItem={(form) => {
              const shortcutActions = (
                <Button as={RouterLink} href={`${match.url}/${form.id}/edit`}>Edit</Button>
              );
              return (
                <ResourceList.Item
                  key={form.id}
                  url={`${match.url}/${form.id}`}
                  shortcutActions={shortcutActions}
                  id={form.id}
                >
                  <Text as="h3">{form.name}</Text>
                  <Text>{form.description || '(No description available)'}</Text>
                </ResourceList.Item>
              );
            }}
          />
        </Card>
        <Box marginTop="4em" marginBottom="4em">
          <Text as="h3">This is on hold while James works on Dynamo form editting</Text>
        </Box>
      </Page>
    );
  }
}

Forms.propTypes = propTypes;
